<template>
  <v-alert v-if="showCountdown" type="warning" outlined text>
    Time Remaining to complete your order for your chosen delivery date 
    <span class="digit font-weight-bold red--text"> {{formatedTimed}} </span>
  </v-alert>
</template>
  

<script>
import moment from "moment";
import {mapGetters,mapMutations} from "vuex"
export default {
  name:"CutOff",
  data:()=>{
    return {
      formatedTimed : '00 : 00 : 00',
      intervalHandle:null,
    }
  },
  computed: {
    ...mapGetters(["retrieveCutOffTimeWarning","retrieveCurrentTrolly"]),
    showCountdown() {
      if(this.retrieveCutOffTimeWarning >= this.remainingWarningMinutes && this.remainingWarningMinutes >0) {
        return true
      }
      return false
    },
    remainingWarningMinutes(){
      // if(this.checkOutBeforeCutOff != 0) {
      //  return  moment(this.checkOutBeforeCutOff).diff(moment(),'minutes')
      // }
      // return 0
      if(this.retrieveCurrentTrolly) {
        return this.retrieveCurrentTrolly.mins_before_cutoff_time
      }
      return 0
    },
    cutOffTime(){
      if(this.retrieveCurrentTrolly) {
        return this.retrieveCurrentTrolly.cut_off
      }
      return 0;
    },

    checkOutBeforeCutOff(){
      if (this.cutOffTime != 0) {
        return  moment.unix(this.cutOffTime).format('YYYY-MM-DD HH:mm')
      }
      return 0
    }
    
  },

  methods: {
    ...mapMutations(["setTrollyInvalid"]),  
    startTimer(){
      var currentTime = moment().unix()
      var diffTime = this.cutOffTime - currentTime
      var duration = moment.duration(diffTime * 1000, 'milliseconds')
      var interval = 1000
      this.intervalHandle = setInterval(()=>{
        duration = moment.duration(duration-interval,'milliseconds');
        if (moment().unix() > this.cutOffTime && this.cutOffTime != 0) {
          console.log('hitting block for reset')
          this.setTrollyInvalid(this.$store.getters.retrieveSelectedTrolly)
          clearInterval(this.intervalHandle)
          this.intervalHandle=null
          this.formatedTimed='00 : 00 : 00'
        } else {
          this.formatTime(duration.hours(), duration.minutes(), duration.seconds())
        }
      }, interval)
      
    },

    formatTime(hrs, min, sec){
      hrs < 10 ? hrs ='0'+hrs :hrs
      min < 10 ? min='0'+min :min
      sec < 10 ? sec='0'+sec : sec
      this.formatedTimed = `${hrs} : ${min} : ${sec}`
      
      },
    },
    
    activated(){
      if(this.showCountdown){
       this.startTimer()
      }
      
    },
    deactivated(){
      this.formatedTimed='00 : 00 : 00'
      clearInterval(this.intervalHandle)
      this.intervalHandle=null
    }

};
</script>

<style scoped>


.digit {
    font-family: 'Roboto Condensed', serif;
    font-size: 18px;
}
</style>